/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const RoxPermissonBookingV3 = {
  permission_booking_v3_create_manual: new Rox.Flag(false),
  permission_booking_v3_create_client: new Rox.Flag(false),
  permission_booking_v3_create_markeplace: new Rox.Flag(false)
};

const BcsPermissionPermissionBookingV3 = {
  config_upselling_product_list: new BcsFlag.JSONFlag({
    legacy: [
      "onepack",
      "regpack",
      "minipack",
      "jagopack",
      "bigpack",
      "bigpackfast",
      "interpack",
      "interpackmaxi",
      "otopack150",
      "otopack250",
      "vippack"
    ],
    retail: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "INTERPACK",
      "INTERPACKMAXI",
      "OTOPACK150",
      "OTOPACK250",
      "VIPPACK",
  ],
    client: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "INTERPACK",
      "OTOPACK150",
      "OTOPACK250",
      "ONEPACK",
    ],
    shipment: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "JUMBOPACK",
      "INTERPACK",
      "OTOPACK150",
      "OTOPACK250",
      "VIPPACK",
      "SAMEDAY",
      "ONEPACK",
    ],
    edit_client: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "INTERPACK",
      "INTERPACKMAXI",
      "OTOPACK150",
      "OTOPACK250",
      "ONEPACK",
      ],
    edit_retail: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "INTERPACK",
      "INTERPACKMAXI",
      "OTOPACK150",
      "OTOPACK250",
      "VIPPACK",
    ],
    reverseJourney: [
      "BOSSPACK",
      "REGPACK",
      "MINIPACK",
      "JAGOPACK",
      "BIGPACK",
      "BIGPACKFAST",
      "INTERPACK",
      "OTOPACK150",
      "OTOPACK250",
      "VIPPACK",
    ]
  }),
  config_min_max_goods_price: new BcsFlag.JSONFlag({
    "retail": { "min": 10000, "max": 150000000 },
    "client": { "min": 1, "max": 1000000000 },
    "shipment_ca": { "min": 10000, "max": 150000000 },
    "shipment_corporate": { "min": 0, "max": 1000000000 }
  })
};

export const FcsPermissionPermissionBookingV3 = {
  exist_booked: new FcsFlag.Flag(false),
  instant_booking_v2: new FcsFlag.Flag(false),
}

export const FlagsPermissionBookingV3 = {
  ...RoxPermissonBookingV3,
  ...BcsPermissionPermissionBookingV3,
  ...FcsPermissionPermissionBookingV3
};

export function initFlagsPermissionBookingV3() {
  // register flags with namespaces for better grouping
  Rox.register("featureBookingV3", RoxPermissonBookingV3);
  BcsFlag.register("featureBookingV3", BcsPermissionPermissionBookingV3);
  FcsFlag.register("featureBookingV3", FcsPermissionPermissionBookingV3);
}
